let tempCounter = 0;
const buildTempId = () => `temp-curso-${tempCounter++}`;

const toBoolean = (value) => (typeof value === "boolean" ? value : value === 1 || value === "1");
const toNumberOrNull = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const num = Number(value);
  return Number.isNaN(num) ? null : num;
};

export const normalizeCurso = (curso = {}, fallback = {}) => {
  const merged = { ...fallback, ...curso };
  const nivelId = merged.nivel_id ?? merged.nivelId ?? merged.nivel?.id ?? null;
  const especialidadId = merged.especialidad_id ?? merged.especialidadId ?? merged.especialidad?.id ?? null;

  const esReentrenamiento = toBoolean(
    merged.es_reentrenamiento ?? merged.esReentrenamiento ?? merged.reentrenamiento ?? false
  );
  const requiereExamen = toBoolean(merged.requiere_examen ?? merged.requiereExamen ?? false);

  return {
    id: merged.id ?? fallback.id ?? fallback.fallbackId ?? buildTempId(),
    nombre: (merged.nombre || "").trim() || "Sin nombre",
    codigoCurso: (merged.codigo_curso || merged.codigoCurso || "").trim(),
    centroId: merged.centro_id ?? merged.centroId ?? merged.centro?.id ?? null,
    centroNombre:
      (merged.centro_nombre ||
        merged.centroName ||
        merged.centro ||
        merged.centroNombre ||
        merged.centroDescripcion ||
        "").trim(),
    nivelId,
    nivelNombre: (merged.nivel || merged.nivelNombre || merged.nivel_nombre || "").trim(),
    especialidadId,
    especialidadNombre: (merged.especialidad || merged.especialidadNombre || merged.especialidad_nombre || "").trim(),
    precioBase:
      merged.precio_base !== undefined && merged.precio_base !== null
        ? Number(merged.precio_base)
        : merged.precioBase !== undefined && merged.precioBase !== null
          ? Number(merged.precioBase)
          : null,
    duracionHoras: toNumberOrNull(merged.duracion_horas ?? merged.duracionHoras),
    montoMinReserva: toNumberOrNull(merged.monto_min_reserva ?? merged.montoMinReserva),
    montoMatricula: toNumberOrNull(merged.monto_matricula ?? merged.montoMatricula),
    activo: toBoolean(merged.activo ?? true),
    esReentrenamiento,
    requiereExamen,
    cursoOficialId: toNumberOrNull(merged.curso_oficial_id ?? merged.cursoOficialId),
    contificoCodigo: merged.contifico_codigo || merged.contificoCodigo || null,
    contificoProductoId: merged.contifico_producto_id || merged.contificoProductoId || null,
    montoComision: toNumberOrNull(merged.monto_comision ?? merged.montoComision),
    createdAt: merged.created_at || merged.createdAt || null,
    updatedAt: merged.updated_at || merged.updatedAt || null,
  };
};

export const buildCursoPayload = (form) => ({
  nombre: form.nombre?.trim() || "",
  codigo_curso: form.codigo_curso?.trim().toUpperCase() || "",
  centro_id: form.centro_id ? Number(form.centro_id) : null,
  nivel_id: form.nivel_id ? Number(form.nivel_id) : null,
  especialidad_id: form.especialidad_id ? Number(form.especialidad_id) : null,
  duracion_horas:
    form.duracion_horas === "" || form.duracion_horas === null || form.duracion_horas === undefined
      ? null
      : Number(form.duracion_horas),
  precio_base:
    form.precio_base === "" || form.precio_base === null || form.precio_base === undefined
      ? null
      : Number(form.precio_base),
  monto_min_reserva:
    form.monto_min_reserva === "" || form.monto_min_reserva === null || form.monto_min_reserva === undefined
      ? 0
      : Number(form.monto_min_reserva),
  monto_matricula:
    form.monto_matricula === "" || form.monto_matricula === null || form.monto_matricula === undefined
      ? 0
      : Number(form.monto_matricula),
  es_reentrenamiento: form.es_reentrenamiento ? 1 : 0,
  requiere_examen: form.requiere_examen ? 1 : 0,
  curso_oficial_id: form.curso_oficial_id ? Number(form.curso_oficial_id) : null,
  activo: form.activo ? 1 : 0,
  contifico_codigo: form.contifico_codigo || null,
  contifico_producto_id: form.contifico_producto_id || null,
  monto_comision: form.monto_comision === "" || form.monto_comision === null || form.monto_comision === undefined
    ? null : Number(form.monto_comision),
});

export const resolveNivelId = (curso, niveles = []) => {
  if (curso?.nivelId) return curso.nivelId;
  const nombre = (curso?.nivelNombre || curso?.nivel || "").trim().toLowerCase();
  if (!nombre) return null;
  const match = niveles.find((n) => (n.nombre || "").trim().toLowerCase() === nombre);
  return match ? match.id : null;
};
